<ng-container *ngIf="currentStep">
	<div class="auth-wrapper overflow-hidden">
		<div class="auth-title pt-16 px-16">
			<div class="img-wrapper mb-2">
				<img
					src="/assets/images/closer-logos/closer-logo-full.webp"
					alt="Closer"
				/>
			</div>
			<h3>{{ currentStep.heading }}</h3>
			<p>{{ currentStep.subHeading }}</p>
			<ul *ngIf="currentStep.list as list" class="list-disc list-inside">
				<li *ngFor="let step of list">{{ step }}</li>
			</ul>
			<p *ngIf="currentStep.paragraph">
				{{ currentStep.paragraph }}
			</p>
		</div>
		<div class="auth-modal-image">
			<div
				*ngIf="currentStep.stepName === states.INVITE; else notInviteStep"
				class="next-step-background"
				[ngStyle]="{ backgroundPositionX: (landscapePosition$ | async) + '%' }"
			></div>
		</div>
		<div class="main-auth-content bg-grey-lightest">
			<div
				class="flex justify-center items-center w-full h-full bg-white pt-6"
				*ngIf="authLoading$ | async"
			>
				<app-icon
					icon="loading"
					class="text-green-light text-9xl"
					[spin]="true"
				></app-icon>
			</div>

			<ng-container *ngIf="!(authLoading$ | async)">
				<ng-container *ngIf="errorMessage; else noErrorMessage">
					<atomic-message-bar type="error">{{
						errorMessage
					}}</atomic-message-bar>
				</ng-container>
			</ng-container>
		</div>
	</div>

	<ng-template #notInviteStep>
		<div class="landscape-background-container">
			<div
				class="landscape-background-mover"
				[style.transform]="'translateX(-' + (landscapePosition$ | async) + '%)'"
			>
				<img src="/assets/images/auth/sign-up-landscape.webp" />
			</div>
		</div>
	</ng-template>

	<ng-template #noErrorMessage>
		<div *ngIf="steps.length > 1" class="flex justify-end text-sm">
			Step {{ currentStepIndex + 1 }} of {{ steps.length }}
		</div>
		<ng-container [ngSwitch]="currentStep.stepName">
			<app-create-user-profile
				class="min-h-full"
				*ngSwitchCase="states.PROFILE"
				(onSubmit)="currentStep.onSubmit($event)"
				[onlyProfile]="steps.length === 1"
				[formData]="createdUserFormData"
			/>
			<app-create-user-business
				class="min-h-full"
				*ngSwitchCase="states.BUSINESS"
				[loading]="creatingBusiness"
				(onSubmit)="currentStep.onSubmit($event)"
				(onBack)="goBack()"
				[formData]="createdBusinessFormData"
			/>
			<app-create-user-invite
				class="min-h-full"
				*ngSwitchCase="states.INVITE"
				[createdByName]="createdByName"
				[createdByEmail]="loggedInUserEmail$ | async"
				[businessName]="businessName"
				(onSubmit)="currentStep.onSubmit($event)"
				(onSendInvites)="createInvite($event)"
				(onBack)="goBack()"
			/>
		</ng-container>
	</ng-template>
</ng-container>
